/**
 * Slash commands for chart-briefing contextual follow-up (must match backend COMMAND_TOOL_MAP / PolicyEngine).
 */
export const CHART_BRIEFING_FOLLOW_UP_ACTIONS: ReadonlyArray<{ label: string; command: string }> = [
  { label: 'Show the full medication table', command: '/medications' },
  { label: 'Show the active problem list', command: '/conditions' },
  { label: 'Show allergies and intolerances', command: '/allergies' },
  { label: 'Show recent labs/vitals', command: '/labs' },
  { label: 'Show recent encounters', command: '/encounters' },
  { label: 'Show procedures', command: '/procedures' },
  { label: 'Show care plans', command: '/careplans' },
  { label: 'Show diagnostic reports', command: '/reports' },
];

export function shouldRenderChartBriefingFollowUpChips(message: {
  role: string;
  isStreaming?: boolean;
  responseMetadata?: { intent_type?: string; suggested_next_questions?: unknown[] };
}): boolean {
  return (
    message.role === 'assistant' &&
    !message.isStreaming &&
    message.responseMetadata?.intent_type === 'chart_briefing' &&
    // #131: SuggestedQuestionsPanel is the canonical Section-3 chip row - this
    // legacy command row is a fallback only, and must not double-render a
    // second chip row when the panel already has suggestions to show.
    !(message.responseMetadata?.suggested_next_questions?.length)
  );
}
